import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = props => {
	return (
		<li className="icon__item">
			<FontAwesomeIcon
				icon={['fab', `${props.type}`]}
				size="6x"
				className={`${props.type}`}
			/>
			<span className="icon__label">{props.name}</span>
		</li>
	);
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js